import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SchoolContext } from './context/SchoolContext';
import Login from './components/auth/Login';
import ProtectedRoute from './components/auth/ProtectedRoute';
import DashboardLayout from './components/layout/DashboardLayout';
import Dashboard from './components/dashboard/Dashboard';
import StudentManagement from './components/students/StudentManagement';
import TeacherManagement from './components/teachers/TeacherManagement';
import CourseManagement from './components/courses/CourseManagement';
import AttendanceManagement from './components/attendance/AttendanceManagement';
import AssessmentManagement from './components/assessments/AssessmentManagement';
import AssignmentManagement from './components/assignments/AssignmentManagement';
import TakeExam from './components/assignments/TakeExam';
import SchoolManagement from './components/school/SchoolManagement';
import ManageSchools from './components/superadmin/ManageSchools';
import { logOut } from './FirebaseAuth';

function MainApp() {
    const { user, loading, school } = useContext(SchoolContext);

    React.useEffect(() => {
        if (school && user.role !== 'SuperAdmin') {
            document.documentElement.style.setProperty('--primary-color', school.primaryColor);
            document.documentElement.style.setProperty('--secondary-color', school.secondaryColor);
        }
    }, [school, user]);

    if (loading) {
        return <div className="flex justify-center items-center h-screen">Loading...</div>;
    }

    return (
        <Router>
            <Routes>
                <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />

                <Route path="/*" element={user ? <DashboardLayout user={user} onLogout={logOut} /> : <Navigate to="/login" />}>
                    <Route index element={<Dashboard />} />

                    {/* School Routes */}
                    <Route path="students" element={<ProtectedRoute user={user} allowedRoles={['Admin', 'Teacher']}><StudentManagement /></ProtectedRoute>} />
                    <Route path="teachers" element={<ProtectedRoute user={user} allowedRoles={['Admin']}><TeacherManagement /></ProtectedRoute>} />
                    <Route path="courses" element={<ProtectedRoute user={user} allowedRoles={['Admin']}><CourseManagement /></ProtectedRoute>} />
                    <Route path="attendance" element={<ProtectedRoute user={user} allowedRoles={['Admin', 'Teacher']}><AttendanceManagement /></ProtectedRoute>} />
                    <Route path="assessments" element={<ProtectedRoute user={user} allowedRoles={['Admin']}><AssessmentManagement /></ProtectedRoute>} />
                    <Route path="assignments" element={<ProtectedRoute user={user} allowedRoles={['Teacher', 'Student']}><AssignmentManagement /></ProtectedRoute>} />
                    <Route path="assignments/:id/take" element={<ProtectedRoute user={user} allowedRoles={['Student']}><TakeExam /></ProtectedRoute>} />
                    <Route path="school" element={<ProtectedRoute user={user} allowedRoles={['Admin']}><SchoolManagement /></ProtectedRoute>} />
                    
                    {/* Super Admin Routes */}
                    <Route path="manage-schools" element={<ProtectedRoute user={user} allowedRoles={['SuperAdmin']}><ManageSchools /></ProtectedRoute>} />

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default MainApp;
